(function ($, window) {
	"use strict";

	$(function () {
		const interval = 250;
		const visibleHeight = 400;
		const activeClass = "to-top--active";
		const $toTop = $(".to-top");
		let didScroll = false;

		$toTop.on("click", function (e) {
			e.preventDefault();
			$("html, body").animate({ scrollTop: 0 }, 500);
		});

		$(window).on("scroll", function () {
			didScroll = true;
		});

		setInterval(function () {
			if (didScroll) {
				handleScroll();
				didScroll = false;
			}
		}, interval);

		const handleScroll = () => {
			const currentScrollTop = $(window).scrollTop() || $("body").scrollTop();

			if (currentScrollTop > visibleHeight) {
				if (!$toTop.hasClass(activeClass)) {
					$toTop.addClass(activeClass);
				}
			} else {
				if ($toTop.hasClass(activeClass)) {
					$toTop.removeClass(activeClass);
				}
			}
		};

		$(window).trigger("scroll");
	});
})(jQuery, window);
